import Colors from './Colors';

const edgeColors2 = [{
  selector: '.er-1-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c2}`
  }
},
{
  selector: '.er-1-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c3}`
  }
},
{
  selector: '.er-1-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c4}`
  }
},
{
  selector: '.er-1-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c5}`
  }
},
{
  selector: '.er-1-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c6}`
  }
},
{
  selector: '.er-1-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c1} ${Colors.c1}`
  }
},
{
  selector: '.er-2-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c1}`
  }
},
{
  selector: '.er-2-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c3}`
  }
},
{
  selector: '.er-2-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c4}`
  }
},
{
  selector: '.er-2-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c5}`
  }
},
{
  selector: '.er-2-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c6}`
  }
},
{
  selector: '.er-2-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c2} ${Colors.c2}`
  }
},
{
  selector: '.er-3-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c1}`
  }
},
{
  selector: '.er-3-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c2}`
  }
},
{
  selector: '.er-3-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c4}`
  }
},
{
  selector: '.er-3-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c5}`
  }
},
{
  selector: '.er-3-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c6}`
  }
},
{
  selector: '.er-3-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c3}`
  }
},
{
  selector: '.er-4-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c3} ${Colors.c1}`
  }
},
{
  selector: '.er-4-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c4} ${Colors.c2}`
  }
},
{
  selector: '.er-4-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c4} ${Colors.c3}`
  }
},
{
  selector: '.er-4-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c4} ${Colors.c5}`
  }
},
{
  selector: '.er-4-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c4} ${Colors.c6}`
  }
},
{
  selector: '.er-4-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c4} ${Colors.c4}`
  }
},
{
  selector: '.er-5-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c1}`
  }
},
{
  selector: '.er-5-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c2}`
  }
},
{
  selector: '.er-5-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c3}`
  }
},
{
  selector: '.er-5-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c4}`
  }
},
{
  selector: '.er-5-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c6}`
  }
},
{
  selector: '.er-5-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c5} ${Colors.c5}`
  }
},
{
  selector: '.er-6-1',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c1}`
  }
},
{
  selector: '.er-6-2',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c2}`
  }
},
{
  selector: '.er-6-3',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c3}`
  }
},
{
  selector: '.er-6-4',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c4}`
  }
},
{
  selector: '.er-6-5',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c5}`
  }
},
{
  selector: '.er-6-6',
  css: {
    'line-fill': 'linear-gradient',
    'line-gradient-stop-colors': `${Colors.c6} ${Colors.c6}`
  }
},
{
  selector: '.no-color-edge',
  css: {
    'color': 'black'
  }
}
];

export default edgeColors2;

